import { apiUrl } from '../utils/api-url';

export interface MethodologyDocument {
  id?: string;
  customerId: string;
  projectId: string;
  templateId: string;
  title: string;
  cafPhase: string;
  status: string;
  version: string;
  markdownContent: string;
  /**
   * Microsoft Specialisation Audit (V1.9.1) controls this document attests evidence for.
   * Populated from the source template's auditControls YAML frontmatter at scaffold time.
   * Null/undefined or empty = no controls tagged on this document.
   */
  auditControls?: string[] | null;
  createdAt?: string;
  updatedAt?: string;
}

export async function listDocuments(customerId: string, projectId: string, token: string): Promise<MethodologyDocument[]> {
  const res = await fetch(apiUrl(`/api/documents?customerId=${encodeURIComponent(customerId)}&projectId=${encodeURIComponent(projectId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to list documents: ${res.status}`);
  return res.json();
}

export async function getDocument(id: string, customerId: string, token: string): Promise<MethodologyDocument> {
  const res = await fetch(apiUrl(`/api/documents/${id}?customerId=${encodeURIComponent(customerId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to get document: ${res.status}`);
  return res.json();
}

export async function updateDocumentStatus(
  id: string, customerId: string, status: string, token: string, force = false,
): Promise<{ id: string; title: string; status: string }> {
  const res = await fetch(apiUrl(`/api/documents/${id}/status?customerId=${encodeURIComponent(customerId)}`), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ status, force }),
  });
  if (!res.ok) throw new Error(`Failed to update status: ${res.status}`);
  return res.json();
}
